import { MaterialIcon } from "@website/icons/material";
import { CounterButtonPropertiesType } from "@website/ui-old/counter-button/counter-button.types";
import { numberConvert } from "@website/utils/number-convert";
import { useCallback } from "react";

/**
 * @deprecated please use @website/ui instead
 */
export const useCounterButton = (properties: CounterButtonPropertiesType) => {
  const {
    color,
    decreaseDisabled,
    increaseDisabled,
    onChange,
    value,
    variant,
    locale,
    "aria-label": ariaLabel
  } = properties;

  const onDecreaseButtonClick = useCallback(() => {
    onChange && onChange(value - 1);
  }, [onChange, value]);

  const onIncreaseButtonClick = useCallback(() => {
    onChange && onChange(value + 1);
  }, [onChange, value]);

  return {
    value: numberConvert(value, { locale: locale || "en" }),
    rootProps: {},
    decreaseButtonProps: {
      "aria-label": ariaLabel ? `${"کاهش"} ${ariaLabel}` : "decrease button",
      color,
      disabled: decreaseDisabled,
      EndIcon: <MaterialIcon name="remove" />,
      onClick: onDecreaseButtonClick,
      equalDimension: true,
      variant
    },
    valueProps: {
      "aria-label": ariaLabel || undefined
    },
    increaseButtonProps: {
      "aria-label": ariaLabel ? `${"افزایش"} ${ariaLabel}` : "increase button",
      color,
      disabled: increaseDisabled,
      EndIcon: <MaterialIcon name="add" />,
      onClick: onIncreaseButtonClick,
      equalDimension: true,
      variant
    }
  };
};
